import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { HeartBreak } from "@phosphor-icons/react";
import api from "@/lib/api";
import { PropertyCard } from "@/components/PropertyCard";
import { SkeletonCard } from "@/components/Loaders";
import { EmptyState } from "@/components/EmptyState";
import { Button } from "@/components/ui/button";

export default function Favorites() {
  const navigate = useNavigate();
  const [items, setItems] = useState(null);

  const load = () => api.get("/favorites").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const toggleFav = async (pid) => {
    await api.post(`/favorites/${pid}`);
    setItems((prev) => prev.filter((p) => p.id !== pid));
  };

  return (
    <div className="px-4 pt-5">
      <h1 className="font-heading text-2xl font-semibold text-stone-900">Favorites</h1>
      <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2">
        {items === null ? (
          [1, 2].map((i) => <SkeletonCard key={i} />)
        ) : items.length === 0 ? (
          <div className="col-span-full">
            <EmptyState icon={HeartBreak} title="No favorites yet" message="Tap the heart on any property to save it here for later." action={<Button className="rounded-full bg-primary hover:bg-green-900" onClick={() => navigate("/explore")}>Explore Properties</Button>} />
          </div>
        ) : (
          items.map((p) => <PropertyCard key={p.id} property={p} isFavorite onToggleFavorite={toggleFav} />)
        )}
      </div>
    </div>
  );
}
